// import React, { useState } from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     Button,
//     Box,
//     Typography,
//     Grid,
// } from '@mui/material';
// import { Close as CloseIcon } from '@mui/icons-material';

// import '../../ContentManagement/Home/Modal/BannerinputGetModal.css' // Import external CSS
// import { MdCancel } from "react-icons/md";

// // import registration_complete_gif from "../../../Assets/registration_successful_gif.gif"
// import SchemeCard from '../../../Components/SchemeCard/SchemeCard';
// import cardImage from "../../../Assets/home_page_Image.png";

// import React, { useState } from "react";
import {
  Box,
  Card,
  CardMedia,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Divider,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

import cardImage2 from "../../../Assets/home_page_Image.png";
import cardImage1 from "../../../Assets/sheme_small_image.png";
import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";
import { Formik, Form } from "formik";
// import CustomInputLogin from "../../../Components/CustomInput/CustomInput";
import { AiFillThunderbolt } from "react-icons/ai";
import { MdCancel } from "react-icons/md";
import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
// import { Navigate, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

// import actions from "../../../../ReduxStore/actions/index";
import { adminUrl } from "../../../constants";
import { toast, ToastContainer } from "react-toastify";
import actions from "../../../ReduxStore/actions";
import { hideButton, showButton } from "../../../ReduxStore/Slices/Operator/buttonSlice";

const SelectSchemeCheckoutModal = ({
  open,
  onClose,
  setSubmittedValues,
  submittedValues,
  modalHeadingName,
  handleNextModal,
  handleSchemeCardModalOpen,
}) => {
  // const cartItems = useSelector((state) => state.cart.cart);
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleAddMoreButton = () => {
    dispatch(showButton());
    handleSchemeCardModalOpen();
    onClose();
  };

  const [cartItems, setCartItems] = useState([
    // { id: 1, name: "Scheme 1", price: 1000, quantity: 1, image: cardImage1 },
    // { id: 2, name: "Scheme 2", price: 10000, quantity: 1, image: cardImage2 },
  ]);

  console.log(cartItems, "cartItemssssssss");
  const handleQuantityChange = (id, delta) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id
          ? { ...item, quantity: Math.max(1, item.quantity + delta) }
          : item
      )
    );
  };

  //   const subtotal = cartItems.reduce(
  //     (total, item) => total + item.price * item.quantity,
  //     0
  //   );

  const customerId = useSelector((state) => state.customer);

  const [rowTableData, setRowTableData] = useState([]);

  const dispatch = useDispatch();
  //   const navigate = useNavigate();

  //   const [cartItems, setCartItems] = useState([]);

  const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
  const UserRole = sessionStorage.getItem("UserRole");

  const sessioncustomer_id = sessionStorage.getItem("sessioncustomer_id");
  const sessionFirstName = sessionStorage.getItem("sessionFirstName");

  const cartItemsLocal = useSelector((state) => state.cart.cart);
  const { getCartItems } = useSelector((state) => state?.getCartItems);

  console.log(getCartItems, "getCartItemssssssss");
  const { incrementQuantity } = useSelector(
    (state) => state?.incrementQuantity
  );
  const { decrementQuantity } = useSelector(
    (state) => state?.decrementQuantity
  );

  const [subtotal, setSubtotal] = useState();

  useEffect(() => {


    if (!open) return; // Only fetch when modal is open

    const fetchData = async () => {
      try {
        const data1 = {
          data: {},
          method: "get",
          apiName: `getCartItems/${customerId.customerId}`,
        };
        await dispatch(actions.GETCARTTREMS(data1));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, [dispatch, customerId, incrementQuantity, decrementQuantity, open]);

  console.log(sessioncustomer_id, "sessioncustomer_idsessioncustomer_id");

  useEffect(() => {
    const tempArr = [];
    getCartItems?.data?.cart_items?.map((item, index) => {
      return tempArr.push({
        plan_id: item.plan_id,
        title: item.plan_details.title,
        value_of_purchase: item.plan_details.value_of_purchase,
        image_url: `${adminUrl}${item.plan_details.image_url}`,
        quantity: item.quantity,
      });
    });
    setRowTableData(tempArr);
  }, [dispatch, getCartItems]);

  useEffect(() => {
    // if (sessioncustomer_id) {
    // Determine cart items dynamically
    const cartItemsDynamic =
      JSON.parse(customerId.customerId) !== null ? rowTableData : [];
    console.log(cartItemsDynamic, "cartItemsDynamic");
    setCartItems(cartItemsDynamic);

    const cartItems2 =
      JSON.parse(customerId.customerId) !== null ? "apiii" : "local";

    console.log(cartItems2, "cartItems2cartItems2");

    const subtotal = rowTableData.reduce(
      (total, item) => total + item.value_of_purchase * item.quantity,
      0
    );

    setSubtotal(subtotal);

    // }
  }, [customerId.customerId, cartItemsLocal, getCartItems, rowTableData]);

  const initialValues = {
    coupon: "",
  };

  const handleSubmit = (values) => {
    console.log("Form values cartItems:", values);

    if (JSON.parse(customerId.customerId) !== null) {
      console.log(getCartItems?.message, "getCartItems?.Message");

      if (getCartItems?.message === "No cart items found for this customer.") {
        toast.warning("Please select the scheme.");
      } else {
        handleNextModal();
        dispatch(hideButton());
      }
    } else {
      toast.warning("Please log in before purchasing the scheme.");
    }

    // Handle form submission logic here
  };

  const handleIncrement = async (item) => {
    if (JSON.parse(customerId.customerId) !== null) {
      const data1 = {
        data: {
          customer_id: customerId.customerId,
          plan_id: item.plan_id,
        },
        method: "patch",
        apiName: `incrementQuantity`,
      };
      await dispatch(actions.INCREMENTQUANTITY(data1));

      console.log("incrementQuantity id");
    } else {
      console.log("incrementQuantity not id", item);

      //   dispatch(incrementQuantityLocalCart(item));
    }
  };

  const handleDecrement = async (item) => {
    if (JSON.parse(customerId.customerId) !== null) {
      const data1 = {
        data: {
          customer_id: customerId.customerId,
          plan_id: item.plan_id,
        },
        method: "patch",
        apiName: `decrementQuantity`,
      };
      await dispatch(actions.DECREMENTQUANTITY(data1));
    } else {
      //   dispatch(decrementQuantityLocalCart(item));
    }
  };

  return (
    <Dialog
      open={open}
      // onClose={onClose}
      fullWidth
      maxWidth="md"
      className="custom-dialog"
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "14px", // Target the Paper component
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={() => {
              onClose();
              dispatch(hideButton());
            }}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle className="custom-dialog-title">
            <Box>
              <Typography className="custom-title-text" color="white">
                {/* {modalHeadingName} */}
                Select Scheme
              </Typography>
            </Box>
          </DialogTitle>
        </Box>

        <DialogContent
          dividers
          sx={{
            padding: 0, // Removes the padding completely
            "& .MuiDialogContent-root": {
              padding: 0, // Ensures no padding inside DialogContent
            },
          }}
        >
          <>
            {/* <MyAppBar /> */}

            <Grid
              container
              spacing={2}
              sx={{
                p: { xs: 2, md: 4 },
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              {/* Product Table */}
              <Grid item xs={12}>
                <TableContainer
                  component={Card}
                  sx={{
                    p: 2,
                    background: "#F7F7F7",
                    border: "none",
                    boxShadow: "none",
                    width: "auto",
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            border: "none",
                            // fontWeight: 700,
                            // fontSize: "16px",
                            whiteSpace: "nowrap", // Prevents text from wrapping
                            overflow: "hidden", // Hides overflow text
                            textOverflow: "ellipsis", // Adds ellipsis for overflow text
                            textAlign: "left",
                          }}
                        >
                          <Typography
                            variant="h5"
                          // fontSize="16px"
                          >
                            Product
                          </Typography>
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "none",
                            whiteSpace: "nowrap", // Prevents text from wrapping
                            overflow: "hidden", // Hides overflow text
                            textOverflow: "ellipsis", // Adds ellipsis for overflow text
                            textAlign: "left",
                          }}
                        >
                          <Typography
                            variant="h5"
                          // fontSize="16px"
                          >
                            Price
                          </Typography>
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "none",
                            whiteSpace: "nowrap", // Prevents text from wrapping
                            overflow: "hidden", // Hides overflow text
                            textOverflow: "ellipsis", // Adds ellipsis for overflow text
                            textAlign: "left",
                          }}
                        >
                          <Typography
                            variant="h5"
                          // fontSize="16px"
                          >
                            Quantity
                          </Typography>
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "none",
                            whiteSpace: "nowrap", // Prevents text from wrapping
                            overflow: "hidden", // Hides overflow text
                            textOverflow: "ellipsis", // Adds ellipsis for overflow text
                            textAlign: "left",
                          }}
                        >
                          <Typography
                            variant="h5"
                          // fontSize="16px"
                          >
                            Total Price
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cartItems.map((item, index) => (
                        <TableRow
                          key={item.id}
                          sx={{
                            borderBottom:
                              index === cartItems.length - 1
                                ? "none"
                                : "1px solid #E0E0E0",
                          }}
                        >
                          <TableCell
                            sx={{
                              whiteSpace: "nowrap", // Prevents text from wrapping
                              overflow: "hidden", // Hides overflow text
                              textOverflow: "ellipsis", // Adds ellipsis for overflow text
                              textAlign: "left",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                              }}
                            >
                              <CardMedia
                                component="img"
                                // image={item.image}
                                image={item.image_url}
                                alt={item.title}
                                sx={{
                                  width: 60,
                                  height: 60,
                                  borderRadius: 1,
                                }}
                              />
                              <Typography
                                variant="body1"
                                sx={{
                                  fontSize: "14px",
                                  color: "#7A7A7A",
                                }}
                              >
                                {item.title}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            variant="body1"
                            sx={{
                              color: "#7A7A7A",
                              whiteSpace: "nowrap", // Prevents text from wrapping
                              overflow: "hidden", // Hides overflow text
                              textOverflow: "ellipsis", // Adds ellipsis for overflow text
                              textAlign: "left",
                            }}
                          >
                            ${item.price}
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                textAlign: "left",
                              }}
                            >
                              <IconButton
                                onClick={() =>
                                  handleDecrement({
                                    ...item,
                                    plan_id: item.plan_id,
                                    title: item.title,
                                    value_of_purchase: item.value_of_purchase,
                                  })
                                }
                              >
                                <CiSquareMinus
                                  style={{
                                    color: "#C38F51",
                                  }}
                                />
                              </IconButton>
                              <Typography variant="body1">
                                {item.quantity}
                              </Typography>
                              <IconButton
                                // onClick={() => handleQuantityChange(item.id, 1)} // Increase quantity
                                onClick={() =>
                                  handleIncrement({
                                    ...item,
                                    plan_id: item.plan_id,
                                    title: item.title,
                                    value_of_purchase: item.value_of_purchase,
                                  })
                                }
                              >
                                <CiSquarePlus
                                  style={{
                                    color: "#C38F51",
                                  }}
                                />
                              </IconButton>
                            </Box>
                          </TableCell>

                          <TableCell
                            sx={{
                              // fontSize: "14px",
                              color: "#C38F51",
                              whiteSpace: "nowrap", // Prevents text from wrapping
                              overflow: "hidden", // Hides overflow text
                              textOverflow: "ellipsis", // Adds ellipsis for overflow text
                              textAlign: "left",
                            }}
                          >
                            <Typography variant="body1">
                              {/* ${item.price * item.quantity} */}$
                              {item.value_of_purchase * item.quantity}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "end",
                    mt: 1,
                  }}
                >
                  <Button
                    onClick={handleAddMoreButton}
                    sx={{
                      textTransform: "none",
                      fontSize: "14px",
                      color: "white",
                      background: "#C38F51",
                      p: "4px 10px",
                    }}
                  >
                    Add more
                  </Button>
                </Grid>
              </Grid>

              {/* Order Summary */}
              <Grid item xs={12}>
                <Card
                  sx={{
                    p: 2,
                    background: "#F7F7F7",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                      <Typography
                        variant="h5"
                        // gutterBottom
                        sx={{
                          color: "#252525",
                          // fontWeight: 700,
                          // fontSize: "16px",
                        }}
                      >
                        Order Summary
                      </Typography>
                      {/* <Divider /> */}
                      {cartItems.map((item) => (
                        <Box
                          key={item.id}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mt: 2,
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              // fontSize: "14px",
                              color: "#7A7A7A",
                            }}
                          >
                            {item.quantity}x {item.name}
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              // fontSize: "14px",
                              color: "#7A7A7A",
                            }}
                          >
                            {/* ${item.price * item.quantity} */}$
                            {item.value_of_purchase * item.quantity}
                          </Typography>
                        </Box>
                      ))}
                      <Divider sx={{ my: 2 }} />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          variant="h5"
                        // sx={{ fontSize: "16px" }}
                        >
                          Sub Total
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{
                            fontSize: "16px",
                            color: "#C38F51",
                          }}
                        >
                          $
                          {getCartItems?.data?.cart_items?.overall_total
                            ? getCartItems?.data?.cart_items?.overall_total
                            : subtotal}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Formik
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                      >
                        {() => (
                          <Form>
                            <Box>
                              <Typography variant="body2">
                                Coupon Code
                              </Typography>
                              <Grid
                                sx={{ width: { xs: "100%", md: "80%" }, mt: 2 }}
                              >
                                <CustomInputLogin
                                  name="coupon"
                                  custPlaceholder="Apply Coupon"
                                />
                              </Grid>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Button
                                variant="contained"
                                type="submit"
                                startIcon={<AiFillThunderbolt />}
                                sx={{
                                  textTransform: "none",
                                  color: "white",
                                  // fontSize: "16px",
                                  padding: "7px 20px",
                                  mt: 2,
                                  minHeight: "30px",
                                  borderRadius: "23px",
                                  background:
                                    "#C38F51 0% 0% no-repeat padding-box",
                                }}
                              >
                                Checkout
                              </Button>
                            </Box>
                          </Form>
                        )}
                      </Formik>
                      <ToastContainer
                        position="top-right"
                        autoClose={1500}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="dark"
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>

            {/* <Footer /> */}
          </>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default SelectSchemeCheckoutModal;
